export default __webpack_public_path__ + "static/media/paloalto_networks.1c24fff2.svg";